import styled from 'styled-components';
import { COLOR_LIGHTER_GREY } from '../../assets/styles/colors';

export default styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 80px);
  background: ${COLOR_LIGHTER_GREY};

  .loading-wrap {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
